export default __webpack_public_path__ + "static/media/payway-fondo.0c648fe5.png";